import { PaymentType } from '@trnsact/trnsact-shared-types';

import { TemplateFormValues, StagesFormValues } from '../../types';

export const initialStagesConstructorFormValue: TemplateFormValues = {
  isActive: false,
  description: '',
  templateName: '',
  businessProcess: '',
  applyRules: {
    paymentType: PaymentType.Financing,
  },
};

export const stagesConstructorFormRow: StagesFormValues = {
  id: null,
  name: '',
  checklist: [],
  recipients: [],
};
